import React, { useState, useEffect, useCallback } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { toast } from "../../../components/AppToast";
import CommonDataTable from "../../../components/CommonDataTable";
// import { getAllUsers } from "../../../services/user/user"; // replace with actual API
import { fetchAllUsers } from "../../../services/tenant/tenant";
import { formatUserType } from "../constant/UserLIstColumns";

export default function UserList({
  onView,
  onEdit,
  refreshKey,
  showCreateButton = false,
  createButtonText = "Create New User",
  createButtonIcon = "bi-plus-lg",
  onCreateClick
}) {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const loadUsers = useCallback(async (pageNo , pageSizeNo) => {
    setLoading(true);
    try {
      const res = await fetchAllUsers(pageNo , pageSizeNo);
      const apiData = res.data;
      const total = res.totalItems;
      const builtRows = (apiData || []).map((rec, idx) => ({
        id: rec._id || idx,
        ...rec,
          viewUserType : formatUserType(rec.userType),
        userstatus: rec.status === "active" ? "Active" : "Inactive",
        partnerName: rec?.partnerDetails?.partner_name,
        formcreatedAt: rec.createdAt
          ? new Date(rec.createdAt).toLocaleString()
          : "",
        formupdatedAt: rec.updatedAt
          ? new Date(rec.updatedAt).toLocaleString()
          : "",
        
      }));

      setRows(builtRows);
      setTotalCount(total);

      const userColumns = [
        {
          field: "__actions",
          headerName: "",
          width: 20,
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
          renderCell: (params) => (
            <IconButton
              size="small"
              onClick={(e) => handleOpenMenu(e, params.row)}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
          ),
        },
         { field: "username", headerName: "Username", width: 150 },
        { field: "email", headerName: "Email", width: 200 },
        { field: "mobile", headerName: "Mobile", width: 150 },
        { field: "viewUserType", headerName: "User Type", width: 150 },
        { field: "tenantUserType", headerName: "Tenant User Type", width: 180 },
        { field: "partnerName", headerName: "Partner Name", width: 200 },
        { field: "userstatus", headerName: "Status", width: 120 },
        { field: "formcreatedAt", headerName: "Created Date", width: 180 },
        { field: "formupdatedAt", headerName: "Updated Date", width: 180 },
      ];

      setColumns(userColumns);
    } catch (error) {
      toast.error(`Failed to load Users: ${error.message || "Unknown error"}`);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => {
    loadUsers(page, pageSize);
  }, [loadUsers, refreshKey , page, pageSize]);

  const handleOpenMenu = (e, row) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const handleView = () => {
    if (menuRow && onView) onView(menuRow);
    handleCloseMenu();
  };

  const handleEdit = () => {

    console.log("menuRow" , menuRow);
    
    if (menuRow && onEdit) onEdit(menuRow);
    handleCloseMenu();
  };

  return (
    <>
      {loading && <div className="text-center py-3">Loading Users...</div>}

      <CommonDataTable
        id="user-table"
        allPossibleColumns={columns}
        initialVisible={columns.map(c => c.field)}
        initialRows={rows}
        height={500}
        rowsPerPageOptions={[10, 25, 50 , 100]}
        // onDataRefresh={loadUsers}
        checkboxSelection
        exportImportPath={"tenant"}
        sampleFileUrl="/samples/user.xlsx"
        sampleFileName="user"
        showCreateButton={showCreateButton}
        createButtonText={createButtonText}
        createButtonIcon={createButtonIcon}
        onCreateClick={onCreateClick}
        enableImportButton={false}
        page={page}
        pageSize={pageSize}
        rowCount={totalCount}
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
          setPage(0);
        }}

        onDataRefresh={async ({ filters = [], page: p = 0, pageSize: ps = pageSize } = {}) => {
          // NOTE: this just forwards the values to your fetchHandler. For now we console.log as requested.
          console.log("ASN ....................... received onDataRefresh:", { filters, page: p, pageSize: ps });
          // call your existing fetchHandler (we'll update it to accept filters)
          // await loadList(p, ps, filters);
        }}
      />

      <Menu
        open={Boolean(menuAnchorEl)}
        anchorEl={menuAnchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem onClick={handleView}>
          <i className="bi bi-eye me-2"></i> View
        </MenuItem>
        <MenuItem onClick={handleEdit}>
          <i className="bi bi-pencil me-2"></i> Edit
        </MenuItem>
      </Menu>
    </>
  );
}
